module.exports = __webpack_public_path__ + "img/center-map.bf0ee2e5.png";